export const STEP_STATUS = {
  complete: 'complete',
  active: 'active',
  upcoming: 'upcoming',
  error: 'error',
};

export const resolveStepStatus = ({ index, activeIndex, hasError }) => {
  if (index < activeIndex) return STEP_STATUS.complete;
  if (index > activeIndex) return STEP_STATUS.upcoming;
  return hasError ? STEP_STATUS.error : STEP_STATUS.active;
};
